export const LionMark = ({ className = "w-8 h-8 text-[#9E7D4E]" }) => (
  <svg
    className={className}
    viewBox="0 0 40 40"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    aria-label="Tse Yaa Kuku lion crest"
    role="img"
  >
    <circle cx="20" cy="20" r="18" strokeDasharray="1 3" />
    <path d="M12 24c0-4 3.5-8 8-8s8 4 8 8c0 4-3.5 6-8 6s-8-2-8-6z" />
    <path d="M20 12v4M16 14l4 2 4-2" />
  </svg>
);
